// extracted by mini-css-extract-plugin
export default {"container":"Header__container___sHjTB","logoContainer":"Header__logoContainer___i6PQ6"};